const initState = {
  LocalesI18n: 'en_US', // 默认英语
}

export const getData = (state, key) => {
  return state[key];
}

const setting = (state = initState, action) => {
  switch (action.type) {
    case 'set-i18n':
      return {
        LocalesI18n: action.data
      }
    default:
      return state
  }
}

export default setting